/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { message } from 'antd'
import { config } from '../../../../config/Structure'
import CrudForm from '../../../Form'
import { connect } from 'react-redux'

const EditPriceOfferForm = ({ dispatch }) => {
  const { priceOffers } = config
  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setLoading(true)
    dispatch(
      config.priceOffers.edit.get({
        query: { _id: id },
        onSuccess: onFetchSuccess,
        onFailure: onFetchFailure,
      }),
    )
  }, [])

  const onSubmit = (values) => {
    setSubmitting(true)
    dispatch(priceOffers.edit.update({ body: { ...values, _id: id }, onSuccess, onFailure }))
  }
  const onSuccess = () => {
    setSubmitting(false)
    message.success('تم التعديل بنجاح')
    history.push(`/priceOffers${location.search}`)
  }

  const onFailure = (error) => {
    setSubmitting(false)
    message.error('حدث خطأ')
  }

  const onFetchSuccess = (records) => {
    const fetchedRecord = records.data[Object.keys(records.data)[0]]
    fetchedRecord.optional_1 = Number(fetchedRecord.optional_1)
    fetchedRecord.optional_2 = Number(fetchedRecord.optional_2)
    setLoading(false)
    setData(fetchedRecord)
  }

  const onFetchFailure = (error) => {
    setLoading(false)
    message.error('حدث خطأ')
  }
  return (
    <CrudForm
      title='تعديل عرض السعر'
      loading={loading}
      fields={config.priceOffers.edit.fields}
      onSubmit={onSubmit}
      buttonText='تعديل'
      initialValues={data}
      submitting={submitting}
    />
  )
}

const mapStateToProps = (state) => ({
  state,
})

export default connect(mapStateToProps)(EditPriceOfferForm)
